// The news post that explains why OpenID sign-in is going and what happened
// to the archived accounts (articles/news/openid-retired.md), and the date it
// promises: OpenID sign-in stops, and unmigrated accounts are archived.
export const openidRetiredPost = '/news/openid-retired'
export const openidSignInEnds = '1 June 2027'
